module.exports = __webpack_public_path__ + "static/media/orange-logo.ce4f9b6e.png";